import { t } from 'i18next';
import { useParams } from 'react-router-dom';
import { useServiceOrder } from '@/hooks/api-hooks';
import ManageServiceOrderCard from '@/components/service-orders/manage-service-order-card';
import { setWebTitle } from '@/lib/format-utils';
import { Loader } from '@mantine/core';


export default function EditServiceOrderPage() {
    const { id } = useParams();

    setWebTitle(`Ord: #${id}`)

    const {
        data,
        isLoading,
    } = useServiceOrder(id!);
    const serviceOrder = data?.data;

    if (!serviceOrder && !isLoading) {
        return (
            <div className="p-4">
                {t('service_order_not_found')}
            </div>
        );
    }

    return (
        <div className="panel-content">
            {isLoading && <Loader size="xs" color='black' />}
            {serviceOrder && <ManageServiceOrderCard serviceOrder={serviceOrder} />}
        </div>
    );
}
